
import PropTypes from 'prop-types';
import MessageBox from '../../Component/MessageBox';

export default function Shipping({ shippingAddress, isDelivery, deliveredAt }) {
  //console.log("shippingAddress, isDelivery, deliveredAt ", isDelivery, deliveredAt)
  // if (Object.prototype.toString.call(shippingAddress) === "[object Array]") {
  //   console.log("Es un array", shippingAddress);
  // } else {
  //   console.log("No es un array", shippingAddress);
  // }
  return (
    <div className="order order-body">
      <h2>Shipping </h2>
      <p>
        <strong>Name:</strong> {shippingAddress.fullName} <br />
        <strong>Address: </strong> {shippingAddress.address},
        {shippingAddress.city},{shippingAddress.postalCode},
        {shippingAddress.country}
      </p>
      {isDelivery ? (
        <MessageBox variant="success">Delivered at {deliveredAt}</MessageBox>
      ) : (
        <MessageBox variant="danger">Not Delivered</MessageBox>
      )}
    </div>
  );
}

Shipping.propTypes = {
  shippingAddress: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
  }),
  isDelivery: PropTypes.bool,
  deliveredAt: PropTypes.bool,
};
